const _local_cache_key = (loc) => `geocode_address_${loc[0].toFixed(6)}_${loc[1].toFixed(6)}`;
const _put_in_cache = (loc, result) => {
    try {
        window.localStorage.setItem(_local_cache_key(loc), result + '|' + new Date().getTime());
    }
    catch (error) {
        //Ошибочка
    }
};
const _cache_ttl = 7 * 24 * 60 * 60 * 1e3; // week
const _get_from_cache = (loc) => {
    let cache_item;
    try {
        cache_item = window.localStorage.getItem(_local_cache_key(loc));
    }
    catch (error) {
        return null;
    }
    if (!cache_item)
        return null;
    const [address, ts] = cache_item.split('|');
    if (new Date().getTime() - parseInt(ts, 10) < _cache_ttl)
        return address;
    return null;
};
export const ZONTGeocoding = {
    geocode_many_and_extract(api, locs, callback, cache_only = false) {
        const results = new Array(locs.length);
        const pending = [];
        for (let i = 0; i < locs.length; i++) {
            const loc = locs[i];
            const addr = _get_from_cache(loc);
            if (addr != null)
                results[i] = addr;
            else
                pending.push([i, loc]);
        }
        if (pending.length === 0) {
            callback(results);
            return true;
        }
        if (cache_only) {
            callback(results);
            return pending.length === 0;
        }
        (async function () {
            try {
                const points = pending.map((task) => ({
                    x: task[1][0],
                    y: task[1][1],
                }));
                const json = await api.reverse_geocode(points);
                if (!json.ok)
                    return;
                for (let i = 0; i < json.addresses.length; i++) {
                    const result = json.addresses[i];
                    const [result_i, loc] = pending[i];
                    results[result_i] = result;
                    if (result != null)
                        _put_in_cache(loc, result);
                }
            }
            finally {
                callback(results);
            }
        })();
        return false;
    },
    geocode_from_cache(locs) {
        const results = new Array(locs.length);
        let all_found = true;
        for (let i = 0; i < locs.length; i++) {
            const addr = _get_from_cache(locs[i]);
            if (addr != null)
                results[i] = addr;
            else
                all_found = false;
        }
        return [all_found, results];
    },
    async geocode_many_and_extract_promise(api, locs, request_from = '') {
        const [ready, results] = ZONTGeocoding.geocode_from_cache(locs);
        if (ready)
            return results;
        const pending = locs
            .map((loc, i) => [i, loc])
            .filter(([i]) => results[i] == null);
        try {
            const points = pending.map(([, loc]) => ({
                x: loc[0],
                y: loc[1],
            }));
            const response = await api.reverse_geocode(points, request_from);
            for (let i = 0; i < response.addresses.length; i++) {
                const result = response.addresses[i];
                const [result_i, loc] = pending[i];
                results[result_i] = result;
                if (result != null)
                    _put_in_cache(loc, result);
            }
            return results;
        }
        catch (error) {
            return results;
        }
    },
};
